module.exports = __webpack_public_path__ + "static/img/2-a1.8147bb38.png";